import { render, staticRenderFns } from "./NoContributed.vue?vue&type=template&id=1dd1ff76&scoped=true&"
import script from "./NoContributed.vue?vue&type=script&lang=js&"
export * from "./NoContributed.vue?vue&type=script&lang=js&"
import style0 from "./NoContributed.vue?vue&type=style&index=0&id=1dd1ff76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd1ff76",
  null
  
)

export default component.exports